import { animate, inView } from 'motion'

export default ({ start_value = 0, raw_end_value = 0 } = {}) => ({
  start_value,
  raw_end_value,

  parseEndValue(value) {
    return parseInt(value) || 0
  },

  checkPrefersReducedMotion() {
    return !window.matchMedia('(prefers-reduced-motion: no-preference)').matches
  },

  init() {
    if (this.checkPrefersReducedMotion()) {
      this.$el.querySelector('.counter').innerHTML = this.parseEndValue(
        this.raw_end_value,
      )

      return
    }

    this.$el.querySelector('.counter').innerHTML = this.start_value

    inView(
      this.$el,
      () => {
        animate(this.start_value, this.parseEndValue(this.raw_end_value), {
          duration: 1,
          ease: 'circOut',
          onUpdate: (latest) =>
            (this.$el.querySelector('.counter').innerHTML = Math.round(latest)),
        })
      },
      { amount: 1 },
    )
  },
})
